import { render, staticRenderFns } from "./parkledsetting.vue?vue&type=template&id=39c48c91&"
import script from "./parkledsetting.vue?vue&type=script&lang=js&"
export * from "./parkledsetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports